module.exports = __webpack_public_path__ + "img/制御工学1_7.8488b941.png";